import { Grid2 } from "@mui/material";
import styles from "./Alert.module.scss";

const Alert = (props) => {
  const { header, subHeader, onClick, button } = props;
  return (
    <Grid2 className={styles.mainContainer}>
      <Grid2 className={styles.mainBox}>
        <Grid2 className={styles.desc}>
          <b>{header}</b> {subHeader}
        </Grid2>
        <Grid2 className={styles.text} onClick={onClick}>
          {button}
        </Grid2>
      </Grid2>
    </Grid2>
  );
};
export default Alert;
